import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css';

const About = () => {
  return (
    <div className="container">
      <div className="page-content">

        <div className="about-hero">
          <p className="about-eyebrow">About Mint Debut</p>
          <h1 className="about-headline">The first drop<br />defines the legacy.</h1>
        </div>

        <div className="about-body">
          <div className="about-section">
            <h2>What we track</h2>
            <p>
              Mint Debut is a registry of genesis NFT collections — the official debut drops
              from the world's most recognised brands, musicians, athletes, and digital artists.
              Not the biggest collections. Not the most traded ones. The <em>first</em> ones.
            </p>
          </div>

          <div className="about-section">
            <h2>Why it matters</h2>
            <p>
              A genesis collection is a permanent record. The blockchain doesn't rewrite history.
              Whatever the market does, the significance of a creator's first on-chain moment is
              immutable — and those debut collections often carry lasting utility, community access,
              and cultural weight that later drops rarely match.
            </p>
          </div>

          <div className="about-section">
            <h2>The categories</h2>
            <p>
              We curate across five verticals: <strong>Brands</strong>, <strong>Music</strong>,{' '}
              <strong>Sports</strong>, <strong>Digital Art</strong>, and <strong>Crypto</strong>.
              Each entry is a verified, official first drop — not fan projects, not derivatives.
              Only the real debut.
            </p>
          </div>

          <div className="about-cta">
            <Link to="/">Browse the registry →</Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;
